// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3i62G","empty":"ModalGraph_empty__209QD"};